import type { TypeInstanceMap } from '@lighthouse/core'
import type { NodeAndEdgeStatusEnum } from '@lighthouse/shared'

import type { FlowRunStatusTab, RunType } from '@/shared/reusable'

export const ITERATION_PADDING = {
    top: 65,
    right: 16,
    bottom: 20,
    left: 16
}

export const FLOW_RUNNING_STATUS_OPTIONS = [
    { label: '全部', value: 'all' },
    { label: '运行中', value: 'RUNNING' },
    { label: '等待中', value: 'PENDING' },
    { label: '已完成', value: 'SUCCESS' },
    { label: '已失败', value: 'FAILED' }
]

export const RUNNING_TYPES_OPTIONS = [
    { label: '全部', value: 'all' },
    { label: '正式运行', value: 'PROD' },
    { label: '测试运行', value: 'TEST' }
]

export const NODE_STATUS_LABEL: Record<NodeAndEdgeStatusEnum, string> = {
    NOT_START: '未开始',
    PENDING: '等待中',
    RUNNING: '运行中',
    SUCCESS: '已完成',
    FAILED: '已失败',
    INTERRUPTED: '被阻断'
}

export const NODE_STATUS_ICON_MAP: Record<NodeAndEdgeStatusEnum, string> = {
    NOT_START: '',
    PENDING: 'Process',
    RUNNING: 'Process',
    SUCCESS: 'TickCircle',
    FAILED: 'ErrorCircle',
    INTERRUPTED: ''
}

export const NODE_STATUS_COLOR: Record<NodeAndEdgeStatusEnum, string> = {
    NOT_START: 'rgba(199, 204, 229, 1)',
    PENDING: 'var(--color-main)',
    RUNNING: 'var(--color-main)',
    SUCCESS: 'var(--color-green-500)',
    FAILED: 'var(--color-red-500)',
    INTERRUPTED: 'rgba(199, 204, 229, 1)'
}

export const NODE_STATUS_TINY_COLOR: Record<NodeAndEdgeStatusEnum, string> = {
    NOT_START: 'rgba(199, 204, 229, 0.16)',
    PENDING: 'var(--color-main-tint)',
    RUNNING: 'var(--color-main-tint)',
    SUCCESS: 'var(--color-green-100)',
    FAILED: 'var(--color-red-100)',
    INTERRUPTED: 'rgba(199, 204, 229, 0.16)'
}

export const NODE_STATUS_SHADOW: Record<NodeAndEdgeStatusEnum, string> = {
    SUCCESS: 'rgba(18, 183, 106, 0.16)',
    FAILED: 'rgba(240, 68, 56, 0.16)',
    PENDING: 'rgba(85, 81, 255, 0.16)',
    RUNNING: 'rgba(85, 81, 255, 0.16)',
    NOT_START: 'rgba(199, 204, 229, 0.16)',
    INTERRUPTED: 'rgba(199, 204, 229, 0.16)'
}

// 工作流
export const RUNNING_STATUS_ICON_MAP = {
    all: '',
    PENDING: 'Process',
    RUNNING: 'Process',
    SUCCESS: 'TickCircle',
    FAILED: 'ErrorCircle'
}

export const RUNNING_STATUS_COLOR_MAP = {
    all: '',
    PENDING: 'var(--color-blue-500)',
    RUNNING: 'var(--color-blue-500)',
    SUCCESS: 'var(--color-green-500)',
    FAILED: 'var(--color-red-500)'
}

export const RUNNING_STATUS_TINY_COLOR_MAP = {
    all: '',
    PENDING: 'var(--color-blue-100)',
    RUNNING: 'var(--color-blue-100)',
    SUCCESS: 'var(--color-green-100)',
    FAILED: 'var(--color-red-100)'
}

export const RUNNING_STATUS_MAP: Record<FlowRunStatusTab, string> = {
    all: '全部',
    PENDING: '等待中',
    RUNNING: '运行中',
    SUCCESS: '已完成',
    FAILED: '已失败'
}

export const RUNNING_TYPE_MAP: Record<RunType, string> = {
    all: '全部',
    PROD: '正式运行',
    TEST: '测试运行'
}

export const innerTypeOptions: { label: string; value: TypeInstanceMap }[] = [
    {
        label: '数值',
        value: 'NUMBER'
    },
    {
        label: '文本',
        value: 'TEXT'
    },
    {
        label: '数组',
        value: 'ARRAY'
    },
    {
        label: '日期',
        value: 'DATE'
    },
    {
        label: '布尔',
        value: 'BOOL'
    },
    {
        label: '富文本',
        value: 'RICH_TEXT'
    }
]
